<template>
  <div class="col-6 col-sm-3 col-xl-2 p-0" :id="getId">
    <div class="card text-center p-0">
      <div class="card-header text-light bd-navbar d-flex justify-content-center p-2">
        <h5>
          <a class="text-light" :href="provider.homepage">{{provider.name}}</a>
        </h5>
        <div v-if="provider.icon" class="pl-2">
          <img class="i42Icon" :src="provider.icon">
        </div>
      </div>
      <content-static-provider-error v-if="hasError" v-on:reload="loadFeed"/>

      <content-static-provider-item v-for="item in feed" v-bind:key="item.id" :news="item"/>

      <content-static-provider-more v-if="hasMoreArticles" v-on:more="loadFeed"/>
      
      <content-static-provider-wait v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ContentStaticProviderWait from "@/components/ContentStaticProviderWait.vue";
import ContentStaticProviderError from "@/components/ContentStaticProviderError.vue";
import ContentStaticProviderItem from "@/components/ContentStaticProviderItem.vue";
import ContentStaticProviderMore from "@/components/ContentStaticProviderMore.vue";

export default {
  name: "ContentStaticProvider",

  data: function() {
    return {
      isLoading: false,
      hasError: false,
      providerFeed: {},
      dummyFeed: [
        {
          title: "Ericsson ist ni",
          link:
            "https://www.golem.de/news/quellcode-ericsson-chef-sieht-tests-von-netzwerktechnik-skeptisch-1903-139845-rss.html",
          displaylink:
            "Quellcode: Ericsson-Chef sieht Tests von Netzwerktechnik skeptisch",
          image: "https://www.golem.de/1903/139845-189406-189403_rc.jpg",
          price: "",
          pubDate: "Thu, 07 Mar 2019 09:10:00 +0100",
          fullText: "<div>Ericsson ist nicht dafÃ¼r, 5G-Updates lange z</div>",
          feedSource: "https://www.golem.de",
          feedIcon: "https://www.golem.de/favicon.ico"
        },
        {
          title:
            "Die Serienproduktion von Embedded MRAM, kurz eMRAM, wurde bei Samsung aufgenommen. Der sonst gerade bei KapazitÃ¤ten offen kommunizierende Hersteller hÃ¤lt...",
          link:
            "https://www.golem.de/news/non-volatile-memory-samsung-liefert-emram-aus-1903-139834-rss.html",
          displaylink: "Non-Volatile Memory: Samsung liefert eMRAM aus",
          image: "https://www.golem.de/1903/139834-189394-189391_rc.jpg",
          price: "",
          pubDate: "Thu, 07 Mar 2019 12:04:00 +0100",
          fullText: "<div>Die Serienprodukti</div>",
          feedSource: "https://www.golem.de",
          feedIcon: "https://www.golem.de/favicon.ico"
        }
      ],
      dummyFeed2: [
        {
          title: "2Ericsson ist ni",
          link:
            "https://www.golem.de/news/quellcode-ericsson-chef-sieht-tests-von-netzwerktechnik-skeptisch-1903-139845-rss.html",
          displaylink:
            "Quellcode: Ericsson-Chef sieht Tests von Netzwerktechnik skeptisch",
          image: "https://www.golem.de/1903/139845-189406-189403_rc.jpg",
          price: "",
          pubDate: "Thu, 07 Mar 2019 09:10:00 +0100",
          fullText: "<div>Ericsson ist nicht dafÃ¼r, 5G-Updates lange z</div>",
          feedSource: "https://www.golem.de",
          feedIcon: "https://www.golem.de/favicon.ico"
        },
        {
          title:
            "2Ãœber das Internet einen vollwertigen Windows-PC streamen - kann das funktionieren? Golem.de testet Blade Shadow und die Konsole Shadow Ghost...",
          link:
            "https://www.golem.de/news/blade-shadow-und-ghost-im-test-windows-pc-streamen-mit-hindernissen-1903-139832-rss.html",
          displaylink:
            "Blade Shadow und Ghost im Test: Windows-PC streamen mit Hindernissen",
          image: "https://www.golem.de/1903/139832-189361-189358_rc.jpg",
          price: "",
          pubDate: "Thu, 07 Mar 2019 08:58:00 +0100",
          fullText: "<div>Ãœber das Internet ein</div>",
          feedSource: "https://www.golem.de",
          feedIcon: "https://www.golem.de/favicon.ico"
        },
        {
          title:
            "2Die Serienproduktion von Embedded MRAM, kurz eMRAM, wurde bei Samsung aufgenommen. Der sonst gerade bei KapazitÃ¤ten offen kommunizierende Hersteller hÃ¤lt...",
          link:
            "https://www.golem.de/news/non-volatile-memory-samsung-liefert-emram-aus-1903-139834-rss.html",
          displaylink: "Non-Volatile Memory: Samsung liefert eMRAM aus",
          image: "https://www.golem.de/1903/139834-189394-189391_rc.jpg",
          price: "",
          pubDate: "Thu, 07 Mar 2019 12:04:00 +0100",
          fullText: "<div>Die Serienprodukti</div>",
          feedSource: "https://www.golem.de",
          feedIcon: "https://www.golem.de/favicon.ico"
        }
      ]
    };
  },

  props: {
    provider: {}
  },

  computed: {
    getId: function() {
      return 'p' + this.provider.id;
    },
    currentFeedFromStore: function() {
      let providerUrl = this.provider.url;
      let providerResult = this.$store.state.content.find(function(data) {
        return data.url == providerUrl;
      });

      if (providerResult === undefined) return {};
      else return providerResult;
    },
    nextPageNo: function() {
      if (this.currentFeedFromStore.nextPageNo === undefined) return 1;
      else return this.currentFeedFromStore.nextPageNo;
    },
    nextPageGuid: function() {
      if (this.currentFeedFromStore.nextPageGuid === undefined) return "";
      else return this.currentFeedFromStore.nextPageGuid;
    },
    hasMoreArticles: function() {
      return this.nextPageNo > 1;
    },
    feed: function() {
      if (this.currentFeedFromStore.feed === undefined) return [];
      else return this.currentFeedFromStore.feed;
    },
    getBaseUrl: function() {
      //return 'http://localhost:8080/dist/';
      return 'https://www.indie42.de/dist/';
      // var locationPath = window.location.pathname.split("/");
      // locationPath.splice(locationPath.length - 1, 1);
      // return (
      //   window.location.protocol +
      //   "//" +
      //   window.location.host +
      //   locationPath.join("/") +
      //   "/"
      // );
    }
  },

  created: function() {},
  components: {
    ContentStaticProviderWait,
    ContentStaticProviderError,
    ContentStaticProviderItem,
    ContentStaticProviderMore
  },

  methods: {
    loadFeed: function() {
      this.isLoading = true;
      this.hasError = false;

      let providerUrl = this.provider.url;

      let requestURL =
        this.getBaseUrl +
        "news.php?v=2&i=1&q=" +
        providerUrl +
        "&s=" +
        this.nextPageNo +
        "&g=" +
        this.nextPageGuid;

      axios
        .get(requestURL, {
          //headers: {
          //  "Access-Control-Allow-Origin": "*"
          //},
          responseType: "json"
        })
        .then(response => {
          console.log('hjdshjds: ' + response);
          if (response == "") {
            this.hasError = true;
          } else {
            this.$store.dispatch("setContent", {
              url: providerUrl,
              nextPageNo: response.data.nextPageNo,
              nextPageGuid: response.data.nextPageGuid,
              feed: response.data.feed
            });
          }
        })
        .catch((/*error*/) => {
          //console.log(error);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    if (this.currentFeedFromStore.feed === undefined) this.loadFeed();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.i42Icon {
  max-height: 20px;
  width: auto;
}
</style>
